import numeral from "numeral";
import { useMemo } from "react";
import { TitleDatailInlineV2Props, TitleDatailInlineV2 } from "./TitleDatailInlineV2";
import { useAuthContext } from "../contexts";
import { formatMoney } from "../helper";

type AmountInlineViewProps = { dd?: number } & Omit<TitleDatailInlineV2Props, "dd">;
export const AmountInlineView = ({ dd = 0, ...others }: AmountInlineViewProps) => {
  const { user } = useAuthContext();
  const amount = useMemo(() => {
    const a = formatMoney(Math.abs(dd));
    let sign = dd < 0 ? "-" : "";
    return `${sign}${user?.currency}${a}`;
  }, [dd]);
  return <TitleDatailInlineV2 dd={amount} {...others} />;
};
